<template>
  <b-container>
    <b-row>
      <b-col cols="10"> </b-col>
      <b-col cols="2" class="spinner_col"
        v-if="$store.state.module.live_en_cours && $store.state.fin_selected_course === 'NON'">
        <SpinnerLive></SpinnerLive>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12" class="content_container">
        <transition name="fade">
          <ListCoureurs></ListCoureurs>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";
import Loading from "@/components/Loading.vue";
import ListCoureurs from "@/components/Live_tab/ListCoureurs.vue";
export default {
  components: {
    Loading,
    SpinnerLive,
    ListCoureurs,
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$store.state.hide_nb_inscrits) {
      this.$router.push({ name: "Courses" });
    }
  },
};
</script>

<style lang="sass">
</style>
